import { schemaLibraryId, schemaLibraryVersionId } from '../fixture-ids';

export const schemaLibraryLegacyAlternates = {
  SCHEMA_LIBRARY_UPDATED: { idKeys: ['schemaLibraryId'] },
  SCHEMA_LIBRARY_DELETED: { idKeys: ['schemaLibraryId'] },
  // The value is a schema_library_versions.id, a DIFFERENT table than the current generation's
  // schemaLibraryId (schema_libraries.id). A bare alias here would resolve against
  // schema_libraries.id and match zero rows, silently -- the object form names the real table. The
  // core alias's whenKey: 'version' keeps legacy rows (no version) from reaching it first.
  SCHEMA_LIBRARY_PUBLISHED: {
    idKeys: [{ key: 'schemaLibraryId', entity: 'schemaLibraryVersion', entityField: 'id' }],
  },
};

export const schemaLibraryLegacyFixtures = {
  SCHEMA_LIBRARY_CREATED: {
    action: 'SCHEMA_LIBRARY_CREATED',
    debugData: { id: schemaLibraryId, name: 'Core Events', description: 'Shared library for core events' },
  },
  SCHEMA_LIBRARY_UPDATED: {
    action: 'SCHEMA_LIBRARY_UPDATED',
    debugData: { schemaLibraryId, name: 'Core Events', description: 'Shared library for core events' },
  },
  SCHEMA_LIBRARY_DELETED: {
    action: 'SCHEMA_LIBRARY_DELETED',
    debugData: { schemaLibraryId, name: 'Core Events', description: 'Shared library for core events' },
  },
  // schemaLibraryId is the VERSION's id. description carries the integer version -- normalized to
  // `version` by the CORE entry's existing keyAliases, which the composed entry already inherits,
  // so it is not redeclared here.
  SCHEMA_LIBRARY_PUBLISHED: {
    action: 'SCHEMA_LIBRARY_PUBLISHED',
    debugData: { schemaLibraryId: schemaLibraryVersionId, name: 'Core Events', description: 3 },
  },
};
